import { Box, Stack } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { useAllTeams } from "../../../../reactQuery/teams";
import { updateUser } from "../../../../services/apiUser";
import { objectToFormData } from "../../../../utils";
import { RFHTextField, RHFSelect } from "../../../../components/RFH";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { CustomButton } from "../../../../components/Button/Button";
import useMutate from "../../../../hooks/useMutate";
import { getSortedTeams } from "../utils/userManagementUtils";

function TeamForm({ params, onClose }) {
  const { isLoading, error, teams, isError } = useAllTeams();

  const { handleSubmit, ...methods } = useForm({
    defaultValues: {
      name: `${params.row.first_name} ${params.row.last_name}`,
      team_id: params.row?.teams?.team_id,
    },
  });

  const { mutate, isPending: loading } = useMutate(updateUser, ["users"], 
    () => {},
    () => {
      //toast.success(res.data.message);
      onClose();
    });

  const submit = useCallback(
    (data) => {
      mutate({
        id: params.row.user_id,
        data: objectToFormData({ team_id: data.team_id }),
      });
    },
    [mutate, params.row.user_id]
  );

  const sortedTeams = useMemo(() => {
    return getSortedTeams(teams?.data?.data?.responseData || []);
  }, [teams]);

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={handleSubmit(submit)}
        noValidate
        className="team-form"
        sx={{
          padding: "14px",
        }}
      >
        <Stack spacing={3}>
          <RFHTextField
            label={"User Name"}
            required
            disabled
            id="name"
            name="name"
            defaultPadding={false}
          />
          <RHFSelect
            label={"Department/Team"}
            required
            id="team_id"
            name="team_id"
            defaultValue={params.row?.teams?.team_id}
            className="update-team-form-select-field"
          >
            {sortedTeams?.map((option) => (
              <CustomMenuItem
                key={`workflow-option-${option.value}`}
                id={`workflow-option-id-${option.value}`}
                value={option.team_id}
              >
                {option.team_name}
              </CustomMenuItem>
            ))}
          </RHFSelect>

          <Box className="team-form-button-container d-flex">
            <CustomButton
              type="submit"
              variant="contained"
              className="team-form-submit-button"
              disabled={loading}
            >
              Update
            </CustomButton>
            <CustomButton
              variant="outlined"
              className="team-form-cancel-button"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </CustomButton>
          </Box>
        </Stack>
      </Box>
    </FormProvider>
  );
}

const isChangeTeamForm = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.user_id === nextProps?.params?.row?.user_id
    && prevProps?.params?.row?.teams?.team_id === nextProps?.params?.row?.teams?.team_id
    && prevProps?.params?.row?.first_name === nextProps?.params?.row?.first_name
    && prevProps?.params?.row?.last_name === nextProps?.params?.row?.last_name
  );
};

export default React.memo(TeamForm, isChangeTeamForm);
